/* eslint-disable */
import { find, register } from '../../../../Javascript/Sysmex/Utils'
import { VanillaSelectBox } from '../../../../Javascript/Libraries/vanillaSelectBox'

const prefix = 'sysmexAtomMultiSelectAjax'

const MultiSelectAjax = el => {
  const componentPrefix = el.dataset.componentprefix
  const searchInputPlaceholder = el.dataset.searchinputplaceholder
  const resetLabel = el.dataset.resetlabel
  const closeLabel = el.dataset.closelabel
  const placeholder = el.dataset.placeholder
  const submitOnClose = el.dataset.submitonclose
  const spinner = find(`.${componentPrefix}loadingIndicator`, el)

  new VanillaSelectBox(el, {
    'search': true,
    'prefix': prefix,
    'searchInputPlaceholder': searchInputPlaceholder,
    'placeHolder': placeholder,
    'resetLabel': resetLabel,
    'closeLabel': closeLabel,
    'submitOnClose': submitOnClose,
    'closeOnClickOutside': true,
    'closeOnReset': true,
    'submitOnCloseCallback': spinner && function () {
      spinner.dataset.isvisible = 1
    }
  })

  // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  const vh = window.innerHeight * 0.01;
  // set the value in the --vh custom property to the root of the document
  el.style.setProperty(`--${prefix}Vh`, `${vh}px`);

}
register('MultiSelectAjax', MultiSelectAjax)
